'use client';

import { useState } from 'react';
import { Menu } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { Button } from '@/src/shared/ui/button';
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from '@/src/shared/ui/sheet';
import { MobileMenu } from './MobileMenu';
import type { NavLink } from '../model/navigation';

type Props = {
  navLinks: NavLink[];
};

export function NavbarClient({ navLinks }: Props) {
  const t = useTranslations('nav.menu');
  const [open, setOpen] = useState(false);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" aria-label={t('open')} className="size-11 lg:hidden">
          <Menu className="size-5" />
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="w-72 p-0">
        {/* visually hidden title for screen readers */}
        <SheetTitle className="sr-only">{t('open')}</SheetTitle>
        <MobileMenu navLinks={navLinks} onClose={() => setOpen(false)} />
      </SheetContent>
    </Sheet>
  );
}
